import React from 'react';
import {FormattedMessage} from 'react-intl';

const ImpulseOrderWrapper = ({subtitle, children}) => {
    return (
        <div className='checkout-content__shadow-block block-width padding-top-2rem mw768-padding-top-2dot5rem z-index-1'>
            <p className='text-header semibold color-gray-900'>
                <FormattedMessage defaultMessage='Ordering'/>
            </p>
            {subtitle &&
                <p className='text-md color-gray-500 padding-top-0dot75rem'>
                    {subtitle}
                </p>
            }
            {children}
        </div>
    )
};

export default React.memo(ImpulseOrderWrapper);